import { CartSeat } from '../classes/seat';
import { IExchangeTicket } from '../classes/ticket-exchange';
import { ActionTypes } from './index';


export function setExchangeTicketMax(numberOfTickets: number) {
    return {
        type: ActionTypes.SET_MAX_TICKET_QUANTITY,
        value: numberOfTickets
    }
}

export function loadExchanges(exchangeTickets: Array<IExchangeTicket>) {
    return {
        type: ActionTypes.LOAD_EXCHANGES,
        value: exchangeTickets
    }
}

export function setActiveExchangeTickets(exchangeTickets: Array<IExchangeTicket>, cartSeats: Array<CartSeat>) {
    return {
        type: ActionTypes.SET_CURRENT_EXCHANGE_TICKETS,
        value: {
            exchangeTickets: exchangeTickets,
            cartSeats:cartSeats
        }
    }
}

export function calculateExchangePrice(originalPrice: number, activeExchangeTickets: Array<IExchangeTicket>): number {
    if (activeExchangeTickets.length === 0)
        return originalPrice;

    return Math.max(originalPrice - activeExchangeTickets[0].oldPrice, 0);
}

//export function isNotExchange() {
//    return {
//        type: ActionTypes.IS_EXCHANGE,
//        value: false
//    }
//}
